/**
 * Same shape as FeasibilityScore receives from ResultsPage — used for recalc with user overrides.
 */
export function buildSearchResultsForFeasibility({ address, propertyInfo, results }) {
  return {
    address,
    parcelData: propertyInfo || { gush: null, helka: null },
    buildingData: propertyInfo?.buildingData || results?.buildingData,
    plans: results?.plans || results || [],
    architecturalPlans: results?.architecturalPlans || results?.plans || [],
    municipality: propertyInfo?.municipality || results?.municipality,
    municipalityCode: propertyInfo?.municipalityCode || results?.municipalityCode,
    gush: propertyInfo?.gush,
    helka: propertyInfo?.helka,
    coordinates: propertyInfo?.coordinates || results?.coordinates,
    parcelGeometry: results?.parcelGeometry,
    advancedLayers: propertyInfo?.advancedLayers,
    sourceHealth: results?.sourceHealth,
  };
}
